export default [

  {
    path: '/gz-live-2022/index',
    name: 'Index',
    component: () => import('@/views/gz-live-2022/index'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/liveList',
    name: 'LiveList',
    component: () => import('@/views/gz-live-2022/liveList'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/live/:id',
    name: 'Live',
    component: () => import('@/views/gz-live-2022/live'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/myLive',
    name: 'MyLive',
    component: () => import('@/views/gz-live-2022/myLive'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/myList',
    name: 'MyLive',
    component: () => import('@/views/gz-live-2022/myList'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/mySubscribe',
    name: 'MyLive',
    component: () => import('@/views/gz-live-2022/mySubscribe'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/schoolInfo/:id',
    name: 'MyLive',
    component: () => import('@/views/gz-live-2022/schoolInfo'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/watchHistory',
    name: 'watchHistory',
    component: () => import('@/views/gz-live-2022/watchHistory'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/search',
    name: 'watchHistory',
    component: () => import('@/views/gz-live-2022/search'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/collegeLive',
    name: 'watchHistory',
    component: () => import('@/views/gz-live-2022/collegeLive'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live-2022/calendar',
    name: 'watchHistory',
    component: () => import('@/views/gz-live-2022/calendar'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2025高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
]